import PhoneMask from '../phone-mask';
import FormGoogleAnalytics from "../form-google-analytics";
import { AbideFunctionMapper } from '../abide-function-mapper';

// State, Region, Community selector
import StateRegionCommunitySelect, { DROPDOWN_MODE_SELECT } from './community-select/state-region-community-select';

// Country and State Data Source
import CountryDataSource from './shared/country-data-source';
import StateProvinceDataSource from './shared/state-province-data-source';
/**
 * This class is used with the Kentico form widgets. It handles validation, form submition, and form submition confirmation.
 */
class GeneralKenticoForm {
    /**
     * Toggle the display of the form submit confirmation section.
     * 
     * @param {bool} bShowConfirmation When true, the submit confirmation section is displayed and the form is hidden.
     * When false, the confirmation section is hidden, and the form is displayed.
     */
    toggleCompletion(bShowConfirmation) {
        let clsInstance = this;

        if (bShowConfirmation) {
            
            //Hide the section of form
            var eleSection = clsInstance.form.closest("section");
            if(eleSection !=undefined && eleSection!=null && eleSection.length> 0)
            {
                // Hide the form section
                eleSection.addClass('hide');
            }
            else
            {
                // Hide the form section
                clsInstance.form.parent().parent().addClass('hide');
            }

            // Show the confirmation message
            clsInstance.submConfirmationContainer.removeClass('hide');
            const submConfirmationElement = clsInstance.submConfirmationContainer[0];
            if (submConfirmationElement) {
                submConfirmationElement.setAttribute("tabindex", "-1");
                submConfirmationElement.focus();
            }
        }
        else {
            // Hide the confirmation message
            clsInstance.submConfirmationContainer.addClass('hide');

            // Show the form section
            clsInstance.form.parent().parent().removeClass('hide');
        }
    }

    /**
     * Build the formPostData used as the ajax payload to the formPostUrl.
     * Includes the form data and GAData
     * @returns object - containing the data to post via ajax
     */
    getPostData() {
        let clsInstance = this;

        var formPostData = clsInstance.getFormData();
        formPostData.GAData = FormGoogleAnalytics().getGAData();
        if (typeof (clsInstance.getPostDataCallback) !== 'undefined') {
            try {
                formPostData = clsInstance.getPostDataCallback(formPostData);
            } catch (error) {
                console.error(`Error occurred in method MoreInfoForm::addPostData(): ${error.message}`);
            }
        }

        // Optionally allows the derived classes to transform the shape of the data
        if (clsInstance.transformFieldsCallback) {
            formPostData = clsInstance.transformFieldsCallback(formPostData);
        }

        return formPostData;
    }

    /**
     * Scan through the form fields and create the object used as the ajax payload to the formPostUrl.
     * @returns object - Object containing the nv pairs of the form fields.
     */
    getFormData() {
        let clsInstance = this;

        let fields = {};

        clsInstance.form.find(":input").each(function () {
            let inputField = $(this);
            let inputFieldName = inputField.attr('name');
            // Skip State dropdown, Regions dropdown value, and Communities dropdown since those fields are
            // only used to browser the communities for selection.
            if (inputFieldName && inputFieldName != 'State' && inputFieldName != 'Regions' && inputFieldName != 'Communities' && inputField.attr('type') != 'submit'
                && inputFieldName != '__RequestVerificationToken') {
                if (inputField.attr('type') == 'checkbox') {
                    fields[inputFieldName] = inputField.is(":checked");
                }
                else {
                    // Prevent XSS. Escape input
                    let escaped = $('<div />').text(inputField.val()).html();
                    fields[inputFieldName] = escaped.trim();
                }
            }
        });

        // The selected communities are the pills.
        if (clsInstance.stateRegionCommunitySelect) {
            let communities = clsInstance.stateRegionCommunitySelect.getSelectedPillSFCommunityNames();
            fields['Communities'] = communities;
        }
        return fields;
    }

    /**
     * Submit data to the formPostUrl via ajax.
     * @returns Promise
     */
    submitData() {
        let clsInstance = this;

        // In CMS preview, just show the completion screen, don't submit
        if (clsInstance.config.isPreviewEnabled) {
            clsInstance.toggleCompletion(true);
            return;
        }

        return new Promise(function (resolve, reject) {
            try {
                if (window.patternLibrary) // set in the sevice request page but only in the pattern library
                {
                    setTimeout(function () {
                        if (resolve) resolve();
                    }, 500);
                    return;
                }

                // Get Anti-CSRF token
                let csrfToken = $('[name="__RequestVerificationToken"]').val();
                let postData = clsInstance.getPostData();

                $.ajax({
                    type: "POST",
                    url: clsInstance.config.postUrlPath,
                    data: postData,
                    cache: false,
                    beforeSend: function (request) {
                        if (csrfToken) {
                            request.setRequestHeader("__RequestVerificationToken", csrfToken);
                        }
                    },
                    success: function (response) {
                        if ((response.Status && response.Status == "200")
                            || response.IsSuccess) {

                            // Send data to GTM
                            var formName = clsInstance.form.data("form-name");
                            if (formName != null && dataLayer ) {
                                dataLayer.push({ 'event': 'formComplete', 'formType': formName });
                            }
                            
                            if (resolve) resolve(response);
                        }
                        else {
                            if (reject) reject(response);
                        }
                    },
                    error: function (request, textStatus, errorThrown) {
                        if (reject) reject(request.responseText);
                    }
                });
            }
            catch (err) {
                if (reject) reject("Error occurrect submittion form:" + err);
            }
        });
    }

    /**
     * This method is called when abide validation is successful. 
     * @param {GeneralKenticoForm} clsInstance - This class instance
     * @param {function} hidePreloader - Function that hides the preloader.
     */
    onSubmitClick(clsInstance, hidePreloader) {
        let continueSubmitData = false;
        if (clsInstance.config.fileUpload && clsInstance.config.fileUpload.uploadFileCallback)
        {
            // call back is set when the GeneralKenticoFileUploadForm is used
            continueSubmitData = clsInstance.config.fileUpload.uploadFileCallback(clsInstance).then(function()
            {
                continueSubmittingData();
            },
            function(error)
            {
                // file upload failed
                displayError(error);
            });
        }
        else
        {
            continueSubmittingData();
        }

        function continueSubmittingData()
        {
            clsInstance.submitData().then((response) => {
                if (clsInstance.generalErrorMessageContainer) {
                    clsInstance.generalErrorMessageContainer.addClass('hide');
                }
                
                // Check if urlRedirect is provided. Redirect after form submission.
                if (clsInstance.urlRedirect != undefined && clsInstance.urlRedirect != '') {
                    window.location.href = clsInstance.urlRedirect;
                } else {
                    // We only want to hide the preloader if were not redirecting after the submit
                    hidePreloader(clsInstance.config.form);
                    // Render the confirmation message
                    clsInstance.toggleCompletion(true);
                }

                // Show the external widget if configured with ID
                clsInstance.showExternalWidget(true);
            }).catch((error) => {
                displayError(error);
            });
        }

        function displayError(error)
        {
            hidePreloader(clsInstance.config.form);
                
            if (error && (""+error).includes("HttpRequestValidationException"))
            {
                console.error("HttpRequestValidationException detected");
            }    
            else
            {
                console.error("Error occurred submitting form");
            }

            if (clsInstance.generalErrorMessageContainer) {
                clsInstance.generalErrorMessageContainer.removeClass('hide');
                let id = clsInstance.generalErrorMessageContainer.first().attr("id");
                document.getElementById(id).scrollIntoView({ behavior: 'smooth' });
            }

        }
    }

    showError(error, hidePreloader)
    {
        hidePreloader(clsInstance.config.form);
        if (error && (""+error).includes("HttpRequestValidationException"))
        {
            console.error("HttpRequestValidationException detected");
        }    
        else
        {
            console.error("Error occurred submitting form");
        }

        if (clsInstance.generalErrorMessageContainer) {
            clsInstance.generalErrorMessageContainer.removeClass('hide');
            let id = clsInstance.generalErrorMessageContainer.first().attr("id");
            document.getElementById(id).scrollIntoView({ behavior: 'smooth' });
        }
    };

    /**
     * Attach abide to the form.
     */
    initializeAbideValidation() {
        let clsInstance = this;

        if (!window.abideFunctionMapper) {
            window.abideFunctionMapper = AbideFunctionMapper();
        }

        window.abideFunctionMapper.map("shm", "forms", clsInstance.config.formId, clsInstance.onSubmitClick);

        $(document).on("formvalid.zf.abide", function (ev, frm) {
            // sectionId was added after form to support multiple instances in widget
            // this code was updated to support both types of input
            var section_id = clsInstance.config.sectionId || clsInstance.config.form;
            if (frm.attr('id') === clsInstance.form.attr('id')) {
                window.showPreLoader(section_id);
                // Call the submit function
                // Code in the submit is asynchronous, so need to pass a function to call after the submission is done
                window.abideFunctionMapper.call("shm", "forms", clsInstance.config.formId, clsInstance, window.hidePreLoader);
            }
            else {
                window.hidePreLoader(section_id);
            }
        });
    }

    /**
     * Shows or hides the external widget as determined by the externalWidgetId
     */
    showExternalWidget(show) {
        let clsInstance = this;

        if (this.externalWidgetContainer)
        {
            if (show) {
                this.externalWidgetContainer.removeClass("hide");
            } else {
                this.externalWidgetContainer.addClass("hide");
            }
        }
    }

    /**
     * Initialize this form. This method *must* be called after being instantiated.
     */
    init() {
        let clsInstance = this;

        clsInstance.form.on('submit', (event) => {
            event.preventDefault();
        });

        PhoneMask().AddPhoneMaskByElement(clsInstance.form.find('input[type="tel"]'));

        clsInstance.initializeAbideValidation();

        clsInstance.showExternalWidget(false);
    }

    /**
     * Class constructor.
     * 
     * @param {object} config - object containing the following properties
     * {
     *      communitySelector: { 
     *        states: Array of state objects
     *            Example:
     *            [{Name: 'California', StateCode: 'CA'}, {Name: 'Florida', StateCode: 'FL'}, ...]
     *        
     *        marketAreasByState: Object representing an associative array where the key is the two char state code and the value is an object containing the state full name and array of market area objects.
     *          Example:
     *          {
     *              'CA': {'StateName': 'California', 'Regions': ['Bay Area', ...]},
     *              'FL': {'Statename': 'Florida', 'Regions': ['Central Florida', ...]},
     *              ...
     *          }
     * 
     *        communitiesByRegion: Object representing associative array where the key is the region (market area) name and the value is an array of community objects.
     *          Example:
     *          {
     *            'Bay Area': [{'SFCommunityName': 'Beach House at the Dunes', 'Name': 'Beach House at the Dunes', 'City': 'Marina', 'State': 'CA'}, ...],
     *            ...
     *          }
     * 
     *        statesDropdown: JQuery selector syntax for the states select form control
     *        marketAreasDropdown: Query selector syntax for the region (market area) select form control
     *        communitiesDropdown: JQuery selector syntax for the communities select form control
     *        pillboxContainer: JQuery selector syntax for the HTML element that contains the selected community pillboxes
     *      },
     *      submConfirmationContainer: JQuery selector syntax for the confirmation message
     *      form: JQuery selector for the lead form
     *      isPreviewEnabled: bool true if viewing the page in the cms admin pagebuilder
     *      postUrlPath: URL path to post the lead to.
     *      formId: Unique identifier for this form instance.
     *      urlRedirect: Url Redirect after form submission
     *      generalErrorMessageContainer: JQuery selector syntax for failed submissions
     *      externalWidgetContainer: JQuery selector syntax for external widget.  External widgets are hidden on page load and shown on submission completion. Interest List and Schedule a Visit are current use cases.
     * }
     */
    constructor(config) {
        this.config = config;

        if (config.generalErrorMessageContainer) {
            this.generalErrorMessageContainer = $(config.generalErrorMessageContainer);
        }

        this.submConfirmationContainer = $(config.submConfirmationContainer);
        this.form = $(config.form);
        this.urlRedirect = config.urlRedirect;
        this.externalWidgetContainer = null;
        if (config.externalWidgetContainer && config.externalWidgetContainer.length > 0 && config.externalWidgetContainer != "#")
        {
            this.externalWidgetContainer = $(config.externalWidgetContainer);
        }

        if (config.communitySelector) {
            let csConfig = config.communitySelector;
            if ($(csConfig.statesDropdown).length > 0 &&
                $(csConfig.marketAreasDropdown).length > 0 &&
                $(csConfig.communitiesDropdown).length > 0 &&
                $(csConfig.pillboxContainer).length > 0) {
                // Set the data used to populate the dropdowns
                this.stateRegionCommunitySelect = new StateRegionCommunitySelect(
                    csConfig.states,
                    csConfig.marketAreasByState,
                    csConfig.communitiesByRegion,
                    this.form,
                    true, // render as multi-select
                    DROPDOWN_MODE_SELECT // Displays Select State instead of All States. All States is Used with filters.
                );

                // Attach the data to the dropdowns
                this.stateRegionCommunitySelect.attachData(
                    csConfig.statesDropdown,
                    csConfig.marketAreasDropdown,
                    csConfig.communitiesDropdown,
                    csConfig.pillboxContainer
                );
            }
        }
        // Style the single select dropdowns in this form
        let singleSelectDropDowns = this.form.find('.shea-custom-dropdown-singleselect');
        singleSelectDropDowns.each(function () {
        window.initCustomDropdowns(this, false);
        });
        
        // Style the multi select dropdowns in this form
        let multiSelectDropDowns = this.form.find('.shea-custom-dropdown-multiselect');
        multiSelectDropDowns.each(function () {
            window.initCustomDropdowns(this, true);
        });

        if (this.stateRegionCommunitySelect)
        {
            // This function is triggerred with the appJsLoaded event.
            // After the event is trigger in the app.js, the following code
            // calls initCustomDropdowns() which resets the state/region/community
            // int he setDropdownsFromUrl().  The setTimeout() allows the
            // app.js intialization to occur first.
            let obj = this;
            setTimeout(function() {
                // Select the dropdown if a community= parameter is specified
                obj.stateRegionCommunitySelect.setDropdowmsFromUrl();
            },250);
        }
    }

    /*
    * Fills the select element with a list of countries
    */
    populateCountrySelect(countrySelectSelector) {
        var countryDataSource = new CountryDataSource();
        countryDataSource.populateSelect(countrySelectSelector);
    }

    /*
    * Fills the select element with a list of countries
    */
    populateStateSelect(stateSelectSelector, addUSStates, addCAProvinces) {
        var stateProvinceData = new StateProvinceDataSource();
        stateProvinceData.populateSelect(stateSelectSelector,addUSStates, addCAProvinces);
    }
}

export { GeneralKenticoForm as default }
